import styled from 'styled-components'
import { FLEX_CENTER_CENTER } from '../../../../../../utils/styles'
import { HeaderSmall, HeaderMed } from '../../../../../../components/Text'
import Button from '../../../../../../components/Button'

export const Sheet = styled.div`
  background: #fff;
  width: 100%;
  border-radius: 4px;
  padding: 1rem;
`

export const Title = styled(HeaderMed)`
  padding: 1rem;
`

export const AllergenList = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-height: 40vh;
  overflow: scroll;
  overflow-x: hidden;
  margin: 1rem 0;
`

export const Allergen = styled.div`
  ${FLEX_CENTER_CENTER};
  flex-direction: column;
  width: 33%;
  padding-bottom: 1rem;
`

export const AllergenIcon = styled.div`
  ${FLEX_CENTER_CENTER};
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
`

export const Icon = styled.img`
  width: 100%;
  height: 100%;
`

export const AllergenLabel = styled(HeaderSmall)`
  font-weight: 500;
  padding: 0.5rem;
  font-size: 0.7rem;
`

export const OKButton = styled(Button)`
  margin: 0 auto;
  padding: 0.5rem 2rem;
`
